import { useState } from 'react'
import Box from '@mui/material/Box'
import IconButton from '@mui/material/IconButton'
import Typography from '@mui/material/Typography'
import { RiClipboardLine, RiCloseLine } from '@/shared/icons/remix'
import { useSpProfile } from '@/features/rewards/api'
import { useSessionStore } from '@/stores/useSessionStore'
import {
  persistWebSurveyIneligibleBannerDismissed,
  shouldShowWebSurveyIneligibleBanner,
  WEB_SURVEY_INELIGIBLE_BANNER_MESSAGE,
} from '../lib/webSurveyIneligibleBanner'

export function WebSurveyIneligibleBanner() {
  const { data: profile } = useSpProfile()
  const userId = useSessionStore((s) => s.user?.id)
  const [dismissed, setDismissed] = useState(false)
  const visible =
    !dismissed && shouldShowWebSurveyIneligibleBanner(profile, userId)

  if (!visible || !userId) return null

  const onDismiss = () => {
    persistWebSurveyIneligibleBannerDismissed(userId)
    setDismissed(true)
  }

  return (
    <Box
      role="status"
      aria-live="polite"
      data-testid="web-survey-ineligible-banner"
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: '16px',
        pl: '20px',
        pr: '12px',
        py: '18px',
        mb: 3,
        borderRadius: '16px',
        bgcolor: '#F4F7FB',
        border: '1px solid #E4EAF2',
        boxSizing: 'border-box',
        width: '100%',
      }}
    >
      <Box
        aria-hidden
        sx={{
          width: 44,
          height: 44,
          borderRadius: '50%',
          bgcolor: '#E8EEF5',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: '#6B7C93',
          flexShrink: 0,
          position: 'relative',
        }}
      >
        <RiClipboardLine size={22} />
        <Box
          sx={{
            position: 'absolute',
            width: 22,
            height: 2,
            bgcolor: '#6B7C93',
            transform: 'rotate(-45deg)',
            borderRadius: '1px',
          }}
        />
      </Box>
      <Typography
        sx={{
          flex: 1,
          fontFamily: 'Inter, sans-serif',
          fontSize: '16px',
          lineHeight: '24px',
          fontWeight: 500,
          color: '#1A2332',
        }}
      >
        {WEB_SURVEY_INELIGIBLE_BANNER_MESSAGE}
      </Typography>
      <IconButton
        aria-label="Dismiss"
        onClick={onDismiss}
        data-testid="web-survey-ineligible-banner-dismiss"
        sx={{ color: '#94A3B8', flexShrink: 0 }}
      >
        <RiCloseLine size={20} />
      </IconButton>
    </Box>
  )
}
